import { motion } from "framer-motion";
import Contact from "../components/Contact";

export default function About() {
  return (
    <div className="min-h-screen bg-transparent text-slate-100 pt-32">
      {/* Hero */}
      <section className="text-center py-12">
        <h1 className="text-4xl font-bold text-slate-100 mb-2">Glass Design</h1>
        <p className="text-lg text-slate-300">30 שנה של איכות, שירות ועיצוב בהתאמה אישית</p>
      </section>

      {/*  main data*/}
      <section className="max-w-5xl mx-auto py-12 px-6 leading-relaxed text-right" dir="rtl">
        <div className="rounded-2xl bg-slate-900/65 border border-slate-700/70 backdrop-blur
                        shadow-[0_14px_50px_rgba(2,6,23,0.10)] p-8 md:p-10">
        <p className="mb-6 text-lg text-slate-200">
        כבר למעלה מ־30 שנה שחברתנו זוכה לקחת חלק בבנייה הישראלית,
        ולתת את נגיעת הזכוכית שלנו במאות בתים, עסקים ומבנים ברחבי הארץ,
        תוך שילוב מערכות חדשניות ועיצובים מתקדמים בעולם הזכוכית.

        בכל פרויקט – קטן כגדול – אנחנו מלווים את הלקוח באופן אישי,
        מהתייעצות ראשונית ומדידה בשטח, ועד ההתקנה הסופית והפתרון המושלם.

        </p>
        <p className="text-lg text-slate-200">
        השילוב בין ניסיון רב, צוות מקצועי וסטנדרט עבודה גבוה ולא מתפשר
        הופך כל עבודה שלנו ליצירה שמדברת בעד עצמה.
        </p>
        </div>
      </section>

      {/* values */}
      <section className="bg-transparent py-10">
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center px-6">
          <motion.div whileHover={{ scale: 1.03 }} className="p-7 bg-slate-900/65 border border-slate-700/70 backdrop-blur shadow-[0_14px_50px_rgba(2,6,23,0.10)] rounded-2xl">
            <div className="text-4xl mb-3">
            <i className="bi bi-tools"></i>
            </div>
            <h3 className="font-semibold text-xl mb-2 text-slate-100">מקצועיות</h3>
            <p>על 30 שנות ניסיון, מקצועיות ודיוק שהופכים כל פרויקט למושלם.</p>
          </motion.div>
          <motion.div whileHover={{ scale: 1.03 }} className="p-7 bg-slate-900/65 border border-slate-700/70 backdrop-blur shadow-[0_14px_50px_rgba(2,6,23,0.10)] rounded-2xl">
            <div className="text-4xl mb-3">
            <i className="bi bi-gem"></i>
            </div>
            <h3 className="font-semibold text-xl mb-2 text-slate-100">איכות</h3>
            <p> הקפדה על שימוש בחומרי גלם האיכותיים שיש,
            בהתאם לתקני האיכות של מכון התקנים הישראלי.
            </p>
          </motion.div>
          <motion.div whileHover={{ scale: 1.03 }} className="p-7 bg-slate-900/65 border border-slate-700/70 backdrop-blur shadow-[0_14px_50px_rgba(2,6,23,0.10)] rounded-2xl">
            <div className="text-4xl mb-3">
            <i className="bi bi-hand-thumbs-up"></i>
            </div>
            <h3 className="font-semibold text-xl mb-2 text-slate-100">שירות אישי</h3>
            <p>אנחנו מלווים כל לקוח משלב הייעוץ ועד ההתקנה 
              עם התייחסות לפרטים הקטנים 
              כדי להבטיח תוצאה מדויקת.</p>
          </motion.div>
        </div>
      </section>

      {/* contact */}
      <Contact />
    </div>
  );
}